import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { useEffect } from 'react'
import './MotoristaLanding.css'

function MotoristaLanding() {
    const { usuario, isLogado } = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
        // Só redireciona pro painel de fretes se for motorista VERIFICADO (PAGO)
        const isVerificado = (usuario?.motorista_verificado === true || usuario?.motoristaVerificado === true) && 
                             usuario?.expiracao_motorista && 
                             new Date(usuario?.expiracao_motorista) > new Date();

        if (isVerificado) {
            navigate('/fretes-disponiveis')
        }
    }, [usuario, navigate])

    const handleAssinar = () => {
        if (!isLogado) {
            alert('Você precisa criar uma conta ou fazer login primeiro!')
            navigate('/cadastro')
            return
        }
        
        // Aqui futuramente chamaremos o Gateway de Pagamento, por ora vamos ao Adicionar Tipo Form
        alert('Aqui entra a integração de Pagamento (R$ 49,90). Após pagar, você completa o perfil de veículo.')
        navigate('/adicionar-tipo?tipo=motorista')
    }

    return (
        <div className="motorista-landing-page">
            <div className="landing-banner">
                <div className="landing-content">
                    <h1>Seja um Motorista Parceiro</h1>
                    <p>Encontre fretes diários, aumente sua renda e expanda seus negócios focados no agronegócio. Por apenas R$ 49,90 ao mês.</p>
                    <button className="btn btn-primary btn-lg mt-4" onClick={() => navigate('/adicionar-tipo?tipo=motorista')}>
                        Assinar Agora (R$ 49,90/mês)
                    </button>
                </div>
            </div>
            
            <div className="landing-features">
                <div className="feature-card">
                    <div className="feature-icon">💸</div>
                    <h3>Sem Taxas Escondidas</h3>
                    <p>Feche o frete diretamente com o produtor rural sem perder margem para a plataforma.</p>
                </div>
                <div className="feature-card">
                    <div className="feature-icon">📈</div>
                    <h3>Acesso Ilimitado</h3>
                    <p>Veja e oferte em todas as demandas de fretes agro publicados na plataforma.</p>
                </div>
                <div className="feature-card">
                    <div className="feature-icon">🛡️</div>
                    <h3>Plataforma Segura</h3>
                    <p>Transportadores verificados e ambiente seguro para suas negociações.</p>
                </div>
            </div>
        </div>
    )
}

export default MotoristaLanding
